export default __webpack_public_path__ + "static/faster-websites-d593b509d6d7de6e3b7b7c4a0cae640e.svg";